"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var styles = require("./WirelessCart.scss");
var ui_components_1 = require("@idp/ui-components");
var ModalProps_1 = require("@idp/ui-components/components/atoms/Modal/ModalProps");
var CartViewPanel_1 = require("../../panels/CartViewPanel");
var PriceContainerProps_1 = require("@idp/ui-components/components/cards/PriceContainer/PriceContainerProps");
var utils_1 = require("@idp/ui-components/utils");
var Utils = require("../../../utils/UtilityFunctions");
var cartUtils = require("../../../utils/CartUtilFunctions");
var RemoveModalContent_1 = require("../shared/RemoveModalContent");
var ReportingService_1 = require("../../../api/ReportingService");
var PrepaidCart_1 = require("../PrepaidCart/PrepaidCart");
var WirelessCartHelper_1 = require("./WirelessCartHelper");
var CartConfiguration_scss_1 = require("../../CartConfigurationContainer/CartConfiguration.scss");
var wlsUtils = require("../../../utils/WirelessUtilFunctions");
var WirelessSavings_1 = require("./WirelessSavings");
var wirelessRTI = require("./WirelessRTI");
var UnauthAccess_1 = require("../../CommonCart/common/UnauthAccess/UnauthAccess");
var WirelessCart = /** @class */ (function (_super) {
    __extends(WirelessCart, _super);
    function WirelessCart(props) {
        var _this = _super.call(this, props) || this;
        _this.state = {
            accessFeeHelpModalDisplay: false,
            bogoSeeOfferModalDisplayed: false,
            isModalOpen: false,
            isRemoveModalOpen: false,
            legalContenFound: false,
            productDetails: {},
            showMonthlySavings: false,
        };
        _this.wirelessSavings = new WirelessSavings_1.default();
        _this.initializeEvents();
        _this.bindThisToFunctions();
        _this.displayLineItems = _this.displayLineItems.bind(_this);
        _this.displayPlanDetails = _this.displayPlanDetails.bind(_this);
        _this.getActivationLineItemContent = _this.getActivationLineItemContent.bind(_this);
        _this.showPromotions = _this.showPromotions.bind(_this);
        _this.showInstallmentMessage = _this.showInstallmentMessage.bind(_this);
        _this.getPlanDetails = _this.getPlanDetails.bind(_this);
        _this.showlineItemContent = _this.showlineItemContent.bind(_this);
        _this.showCartView = _this.showCartView.bind(_this);
        _this.showNewSavingAndPromo = _this.showNewSavingAndPromo.bind(_this);
        _this.getAccessoryFragments = _this.getAccessoryFragments.bind(_this);
        return _this;
    }
    WirelessCart.prototype.componentWillMount = function () {
        var payload = cartUtils.getWirelessCart();
        if (payload && payload.wirelessCart) {
            this.cartData = payload && payload.wirelessCart;
            this.orderSubType = payload.metadata && payload.metadata.metadata && payload.metadata.metadata.orderSubType;
            this.cartMetaData =
                payload.metadata && payload.metadata.metadata && payload.metadata.metadata.wirelessMetadata;
            this.wlsEarlyUpgradePriceFeature = payload.wirelessEarlyUpgradePriceFeature;
            this.b2bDetail = payload.b2bDetail || {};
            this.shippingDetails = payload.shippingDetails;
            this.savingsPromoFlags = cartUtils.getSavingsPromoFlags();
        }
        this.isAALFlow = Utils.isAALFlow();
        this.isMixAndMatch = this.cartData && this.cartData.mixAndMatch;
        this.eapFlowContext = cartUtils.getEAPDetails();
        this.payload = payload;
        if (this.eapFlowContext && this.eapFlowContext.isEAPFlow &&
            (this.eapFlowContext.eapFlowType === 'NEW_EAP_ON' || this.eapFlowContext.eapFlowType === 'AAL_EAP_ON')) {
            this.hideEditAndRemoveLink = true;
        }
    };
    WirelessCart.prototype.componentDidMount = function () {
        var _this = this;
        if (!Utils.isEnableValidateInventory()) {
            this.getEstDeliveryDates();
        }
        this.savingsPromoFlags = cartUtils.getSavingsPromoFlags();
        cartUtils.globalNavForSMBCustomer();
        var attAdminFeeLegal = Utils.getLegalInfo(this.cartSummaryCMSData, this.externalOrderSourceType);
        if (this.payload && this.payload.addOnDueAmount && this.payload.addOnDueAmount !== 0 &&
            attAdminFeeLegal && attAdminFeeLegal.govTaxLegal) {
            var legalObj = attAdminFeeLegal.govTaxLegal;
            var legalContent_1 = {};
            cartUtils.getLegalIDPData(legalObj.legalModalPath, legalContent_1, legalObj.legallinkText, legalObj.shortText).then(function (legaldataobj) {
                legalContent_1 = legaldataobj;
                _this.govTaxandFeeLegal = legalContent_1;
                _this.setState({ legalContenFound: _this.state.legalContenFound });
            });
        }
    };
    WirelessCart.prototype.showNewSavingAndPromo = function () {
        if (this.externalOrderSourceType) {
            return (React.createElement(React.Fragment, null, " "));
        }
        return (this.wirelessSavings.getSavingsAndPromos({
            eapFlowContext: this.eapFlowContext,
            isExpressFlow: this.isExpressUp(),
            isMixAndMatch: this.isMixAndMatch,
            losgData: this.filteredLosgsData, payLoad: this.payload,
            promoPanelEvents: {
                doLoading: this.props.promoPanelEvents && this.props.promoPanelEvents.doLoading,
                priceBarUpdates: this.props.promoPanelEvents && this.props.promoPanelEvents.priceBarUpdates,
                showSaveCartModal: this.props.promoPanelEvents && this.props.promoPanelEvents.showSaveCartModal
            },
            promoPanelOptions: { autoExpandPromoSection: this.props.promoPanelOptions &&
                    this.props.promoPanelOptions.autoExpandPromoSection,
                displayCloserCoupon: this.props.promoPanelOptions &&
                    this.props.promoPanelOptions.displayCloserCoupon,
            },
            promotions: this.cartData.promotions,
            rewardModalEvent: this.showSavingRewardModal,
            savingsPromoFlags: this.savingsPromoFlags,
            showRewardModal: this.state.showRewardModal,
        }));
    };
    WirelessCart.prototype.render = function () {
        var _this = this;
        var _a, _b, _c, _d;
        var isWirelessApplicable = false;
        var losgs = {};
        var gnsession = Utils.getCookie('GNSESS');
        var tempName = gnsession ? JSON.parse(gnsession).FN : null;
        var userName = tempName ? tempName[0].toUpperCase() + tempName.substring(1) : null;
        this.isCommonCart = this.props && this.props.options && this.props.options.isCommonCartBsse;
        this.payload = cartUtils.getWirelessCart();
        var eSimEligible = false;
        var isPSC = this.cartData && this.cartData._cartCreationSource === 'PSC';
        if (this.payload) {
            this.cartData = this.payload ? this.payload.wirelessCart : null;
            isWirelessApplicable = !!this.cartData;
            losgs = isWirelessApplicable && this.cartData.losgs;
            this.externalOrderSourceType = wlsUtils.externalOrderSource(this.payload);
            this.filteredLosgsData = [];
            var losgList = Object.values(losgs);
            if (this.externalOrderSourceType) {
                var ctnNo_1 = '';
                var subscriberName_1 = {};
                losgList.forEach(function (losg) {
                    if (losg && losg.losgType && losg.losgType.toUpperCase() === 'NO_CHANGE') {
                        ctnNo_1 = losg.extraParams && losg.extraParams.associatedCtn || '';
                        if (losg.subscriberName) {
                            subscriberName_1 = losg.subscriberName || {};
                        }
                    }
                });
                losgList.forEach(function (losg) {
                    if (ctnNo_1 && losg && losg.primaryIndicator && losg.displayLine) {
                        losg.extraParams.associatedCtn = ctnNo_1;
                        if (subscriberName_1) {
                            losg.subscriberName = subscriberName_1;
                        }
                    }
                });
            }
            losgList.sort(wlsUtils.sortLogs);
            this.filteredLosgsData = losgList.filter(this.filterLosgs);
            this.sdpData = Utils.getSdpData(losgs, this.isMixAndMatch);
            this.flagExpressUpCapacityLink = this.payload.enableCapacityExpUpgrade;
            this.shippingDetails = this.payload.shippingDetails;
            this.newWireless = cartUtils.isNewWirelessPostpaidView();
            this.downPaymentInfo = wlsUtils.isDownPaymentRequired(this.filteredLosgsData, this.isExpressUp());
            this.isDownPaymentSeePricingDetails = wlsUtils.isPrescreenNegativePricingDetailsDisplay(this.payload);
            this.filteredLosgsData.forEach(function (losg) {
                eSimEligible = wlsUtils.isBYODAndEsim(losg) && Utils.getIXPValue('svc-byod-esim-aal');
            });
        }
        if (this.identifyPreapidCart()) {
            return (React.createElement(PrepaidCart_1.default, { events: { onEdit: this.props.events.onEdit, doLoading: this.props.events.doLoading }, options: {
                    isExpandView: (_a = this.props.options) === null || _a === void 0 ? void 0 : _a.isExpandView,
                    isExpressUpgradeView: (_b = this.props.options) === null || _b === void 0 ? void 0 : _b.isExpressUpgradeView,
                }, prepaidEvents: {
                    authSaveCartMessage: function () { return _this.props && _this.props.prepaidEvents &&
                        _this.props.prepaidEvents.authSaveCartMessage; },
                    getLegalData: Utils.getLegalData,
                    onItemEdit: this.editLineForPscCustomers, onItemRemove: this.removeLineForPscCustomers,
                    onSubmit: function () { return _this.props && _this.props.prepaidEvents &&
                        _this.props.prepaidEvents.onSubmit; },
                    showLegalModal: this.showExpUpLegalModal,
                } }));
        }
        else {
            return (React.createElement("div", null, isWirelessApplicable &&
                React.createElement("div", { className: styles.wirelessCartView },
                    !this.isExpressUp() && !this.isUnauthAccess &&
                        React.createElement(CartViewPanel_1.default, { testId: utils_1.default('Wireless', 'CartViewPanel', 'LineItem'), data: this.getCartViewPanelData(this.cartData), events: this.cartViewEvents, options: {
                                billEstimatorHeading: (_c = this.cartSummaryCMSData) === null || _c === void 0 ? void 0 : _c.billEstimatorHeadingText,
                                billEstimatorMessage: (_d = this.cartSummaryCMSData) === null || _d === void 0 ? void 0 : _d.billEstimatorMessageText,
                                commonCartLegalLabel: Utils.getCommonCartLegalLabel(this.externalOrderSourceType, this.cartSummaryCMSData),
                                externalOrderSource: this.externalOrderSourceType,
                                hideEditAndRemove: this.lobHideEditAndRemoveLink(),
                                hidedueTodaySeeDetails: this.eapFlowContext.isEAPFlow,
                                isCommonCart: this.isCommonCart,
                                isRemoveAllButtonApplicable: (this.cartData && this.cartData.eligibleActions) ?
                                    this.cartData.eligibleActions.indexOf('REMOVE') > -1 : false,
                                isTaxApplied: true,
                                monthlySavings: this.props.options && this.props.options.monthlySavings,
                                newSavingPromoPanel: this.savingsPromoFlags.savingsPromoComponentDisplay,
                                planType: wlsUtils.getPlanType(this.cartData),
                                showAccordions: this.props.options && !!this.props.options.showBundlesTreatment,
                                zipCodeEdit: this.isCommonCart ?
                                    Utils.populateZipEditdetailsForCommonCart(this.filteredLosgsData, this.cartSummaryCMSData) :
                                    Utils.populateZipEditdetails(this.cartData, this.cartSummaryCMSData),
                            } },
                            wirelessRTI.commonDeliveryMessage(this.cartSummaryCMSData.rtiCommonDeliveryText, this.payload),
                            " ",
                            this.displayLineItems(),
                            " ",
                            this.getPlanDetails(),
                            this.cartSummaryCMSData.titleATTFees &&
                                !Utils.IsBsseFlow() && this.showAttAdminFees(this.payload),
                            this.renderShippingDetails(),
                            isPSC && this.newWireless &&
                                ((wlsUtils.isAutoBillPayEligible() || wlsUtils.isAutoBillPaySelected()
                                    || wlsUtils.isAutoBillPayPromoAmount() > 0) && !cartUtils.isCartHasOnlyFNLines())
                                && this.showABPComponent(),
                            (this.payload.wirelessCart.addAnotherDeviceEligible
                                && ((isPSC && this.newWireless && !cartUtils.isParkLosgs(this.filteredLosgsData))
                                    || eSimEligible || wlsUtils.isCaribbeanFlow()))
                                && this.showAddALineComponent(this.filteredLosgsData, this.cartSummaryCMSData)),
                    this.isUnauthAccess && React.createElement(React.Fragment, null,
                        React.createElement("section", { className: styles.expupSectionWhite },
                            this.displayLineItems(),
                            " ",
                            this.getPlanDetails()),
                        React.createElement("section", { className: styles.expupSectionWhite },
                            React.createElement(UnauthAccess_1.default, null))),
                    !this.isUnauthAccess && React.createElement(React.Fragment, null,
                        this.bogoModalBlock(),
                        React.createElement(ui_components_1.Modal, { testId: utils_1.default('WLS', 'Modal', 'ConfirmRemove'), options: {
                                center: true,
                                className: { modalContentClass: CartConfiguration_scss_1.rennyModalCloseBtn },
                                show: this.state.isRemoveModalOpen,
                                showClose: true,
                                size: ModalProps_1.ModalSizes.MEDIUM,
                                tabIndex: 0,
                            }, events: {
                                onClose: function () {
                                    _this.reportingService.firePageLoadEvent(ReportingService_1.PageUrls.CART_PAGE);
                                    _this.toggleRemoveModal();
                                },
                            } },
                            React.createElement(RemoveModalContent_1.default, { testId: utils_1.default('WLS', 'RemoveModalContent', 'ConfirmRemove'), events: {
                                    onCancelClick: function () { _this.toggleRemoveModal(); },
                                    onRemoveClick: function () { _this.toggleRemoveModal(true); },
                                }, data: {
                                    currentLOB: 'WLS',
                                    isBundleinCart: Utils.isBundleinCart().isBundle,
                                    isSonosinCart: Utils.IsSONOSAccessoryInCart(),
                                } })),
                        this.acessFeeHelpBlock(),
                        !this.isExpressUp() && this.savingsPromoFlags &&
                            this.savingsPromoFlags.savingsPromoComponentDisplay &&
                            React.createElement("div", { className: styles.savingsPromoContainer }, this.showNewSavingAndPromo())))));
        }
    };
    WirelessCart.prototype.getPlanDetails = function () {
        return (React.createElement(React.Fragment, null,
            !(this.isMixAndMatch || wlsUtils.isCaribbeanFlow()) && this.displayPlanDetails(),
            !this.isMixAndMatch && this.displayPlanDetailsinModal(this.payload) &&
                this.renderPlanModalDetails(this.cartData)));
    };
    WirelessCart.prototype.renderShippingDetails = function () {
        if (this.shippingDetails &&
            this.shippingDetails.shippingMethod &&
            WirelessCartHelper_1.default.DISPLAY_SHIPPING_TYPES.indexOf(this.shippingDetails.shippingMethod.toUpperCase()) > -1 &&
            Number(this.shippingDetails.shippingPrice) > 0) {
            var shippingDisplayName = this.cartSummaryCMSData.shippingData &&
                this.cartSummaryCMSData.shippingData[this.shippingDetails.shippingMethod] ?
                this.cartSummaryCMSData.shippingData[this.shippingDetails.shippingMethod] :
                this.cartSummaryCMSData.shippingLabel;
            return (React.createElement("div", { id: utils_1.default('WRLS', 'Shipping', 'Details'), className: [styles.lineItems,
                    styles.shippingLine].join(' ') },
                React.createElement(ui_components_1.Label, { testId: utils_1.default('WRLS', 'Shipping', 'Type'), data: { isDecodingRequired: false, text: shippingDisplayName }, options: { className: styles.itemName } }),
                React.createElement(ui_components_1.PriceContainer, { testId: utils_1.default('WRLS', 'Shipping', 'Price'), data: { price: Number(this.shippingDetails.shippingPrice) }, options: {
                        className: styles.lineItem,
                        decimalPoints: 2,
                        type: PriceContainerProps_1.PricingType.XSMALL,
                    } })));
        }
        else {
            return (React.createElement(React.Fragment, null));
        }
    };
    WirelessCart.prototype.getCartViewPanelData = function (cart) {
        var dueTodayPriceAmount = 0;
        var dueMonthlyPriceAmount = 0;
        var due1stBillPriceAmount = 0;
        var oneTimeCreditAmount = 0;
        this.earlyUpgradeAmount = this.wlsEarlyUpgradePriceFeature && cart.earlyUpgradeAmount || 0;
        var newCartItemsAmount = this.wlsEarlyUpgradePriceFeature && cart.newCartItemsAmount || 0;
        var upgradeOptionType = cart.upgradeOption && cart.upgradeOption.type || 'NONE';
        var upgradeOptionTypeTooltipTxt = '';
        if (upgradeOptionType.toUpperCase() === 'PAYOFF') {
            upgradeOptionTypeTooltipTxt = "This is your remaining installment plan balance for your current device.\n             Pay this amount in full today to upgrade early and keep your phone.";
        }
        else if (upgradeOptionType.toUpperCase() === 'PAYUP') {
            upgradeOptionTypeTooltipTxt = "Pay this amount toward your existing installment plan to become eligible for an upgrade.\n             You'll need to trade in your current device within 14 days, and it must be in good, working condition.";
        }
        else {
            upgradeOptionTypeTooltipTxt = '';
        }
        /* istanbul ignore else */
        if (typeof cart.totalLobDueToday !== 'undefined') {
            dueTodayPriceAmount = cart.totalLobDueToday;
        }
        /* istanbul ignore else */
        if (typeof cart.totalLobDueMonthly !== 'undefined') {
            dueMonthlyPriceAmount = cart.totalLobDueMonthly;
        }
        /* istanbul ignore else */
        if (typeof cart.totalLob1stBill !== 'undefined') {
            due1stBillPriceAmount = cart.totalLob1stBill;
        }
        /* istanbul ignore else */
        if (typeof cart.existingLineOneTimeCredit !== 'undefined') {
            oneTimeCreditAmount = cart.existingLineOneTimeCredit;
        }
        if (Object.values(cart.losgs)[0].losgType.toUpperCase() === 'CHANGE') {
            return {
                bsseIncludeTaxLabel: Utils.includeTaxLabel(cart, this.cartSummaryCMSData),
                bsseSavingsLabel: this.cartSummaryCMSData.bsseSavingsLinkText,
                bsseServicePeriodLabel: Utils.servicePeriodLabel(cart.account, this.cartSummaryCMSData),
                due1stBillPrice: due1stBillPriceAmount,
                dueMonthlyLabel: Utils.getDueMonthlyLabel(this.isCommonCart, this.externalOrderSourceType, this.cartSummaryCMSData), dueMonthlyPrice: dueMonthlyPriceAmount,
                dueOneTimeCreditLabel: this.cartSummaryCMSData.bsseOneTimeCreditLabel,
                dueOneTimeCreditSubLabel: Utils.getOneTimeCreditSubLabel(cart.account, cart.losgs, this.cartSummaryCMSData),
                dueOneTimeLabel: Utils.getDueOneTimeLabel(this.externalOrderSourceType, this.cartSummaryCMSData),
                dueTodayFirstMonth: cart.dueTodayFirstMonth, dueTodayOneTime: cart.dueTodayOneTime,
                dueTodayOneTimeTaxes: cart.dueTodayOneTimeTaxes, dueTodayPrice: dueTodayPriceAmount,
                earlyUpgradeAmount: this.earlyUpgradeAmount,
                lineOfBusinessName: this.identifyPreapidCart() ?
                    this.cartSummaryCMSData.byodPlanLineHeading : this.cartSummaryCMSData.lineOfBusinessName,
                newCartItemsAmount: newCartItemsAmount,
                oneTimeCreditAmount: oneTimeCreditAmount,
                removeItemsLinkLabel: this.identifyPreapidCart() ?
                    this.prepaidremoveItemsLinkLabel : this.cartSummaryCMSData.removeItemsLinkLabel,
                upgradeOptionTypeTooltipTxt: upgradeOptionTypeTooltipTxt,
                wirelessUpgradeDisplayName: cart.wirelessUpgradeDisplayName || '',
            };
        }
        else {
            var legalInfo = Utils.getLegalInfo(this.cartSummaryCMSData, this.externalOrderSourceType);
            var dueMonthlyLegalContents = legalInfo.dueMonthlyLegal;
            var dueTodayLegalContents = legalInfo.dueTodayLegal;
            var dueFirstMonthLegalContents = legalInfo.dueFirstMonthLegal;
            return {
                bsseIncludeTaxLabel: Utils.includeTaxLabel(cart, this.cartSummaryCMSData),
                bsseSavingsLabel: this.cartSummaryCMSData.bsseSavingsLinkText,
                bsseServicePeriodLabel: Utils.servicePeriodLabel(cart.account, this.cartSummaryCMSData),
                due1stBillModalLegalContents: dueFirstMonthLegalContents,
                due1stBillPrice: due1stBillPriceAmount, dueMonthlyLabel: Utils.getDueMonthlyLabel(this.isCommonCart, this.externalOrderSourceType, this.cartSummaryCMSData),
                dueMonthlyModalLegalContents: dueMonthlyLegalContents,
                dueMonthlyPrice: dueMonthlyPriceAmount,
                dueOneTimeCreditLabel: this.cartSummaryCMSData.bsseOneTimeCreditLabel,
                dueOneTimeCreditSubLabel: Utils.getOneTimeCreditSubLabel(cart.account, cart.losgs, this.cartSummaryCMSData),
                dueOneTimeLabel: Utils.getDueOneTimeLabel(this.externalOrderSourceType, this.cartSummaryCMSData),
                dueTodayFirstMonth: cart.dueTodayFirstMonth, dueTodayModalLegalContents: dueTodayLegalContents,
                dueTodayMonthlyLabel: Utils.getDueTodayMonthlyLabel(this.payload, this.cartSummaryCMSData),
                dueTodayOneTime: cart.dueTodayOneTime, dueTodayOneTimeTaxes: cart.dueTodayOneTimeTaxes,
                dueTodayPrice: dueTodayPriceAmount, earlyUpgradeAmount: this.earlyUpgradeAmount,
                lineOfBusinessName: this.identifyPreapidCart() ?
                    this.cartSummaryCMSData.byodPlanLineHeading : this.cartSummaryCMSData.lineOfBusinessName,
                newCartItemsAmount: newCartItemsAmount,
                oneTimeCreditAmount: oneTimeCreditAmount,
                removeItemsLinkLabel: this.identifyPreapidCart() ?
                    this.prepaidremoveItemsLinkLabel : this.cartSummaryCMSData.removeItemsLinkLabel,
                upgradeOptionTypeTooltipTxt: upgradeOptionTypeTooltipTxt,
                wirelessUpgradeDisplayName: cart.wirelessUpgradeDisplayName || '',
            };
        }
    };
    WirelessCart.prototype.displayLineItems = function () {
        var _this = this;
        var isMDPPInsurance = Utils.isMDPPInsuranceSelected(this.filteredLosgsData);
        return (React.createElement(React.Fragment, null, this.filteredLosgsData.map(function (losg, index) {
            var _a, _b;
            if (losg.losgType.toUpperCase() === 'CHANGE' && !losg.displayLine) {
                return '';
            }
            var ctnNumber = losg && losg.extraParams && losg.extraParams.associatedCtn;
            var lineNumber = ctnNumber ? ': ' + ("" + Utils.
                formatPhoneNumberWithDot(ctnNumber)) : index + 1;
            var editUrl = wlsUtils.getEditUrl(_this.cartData, _this.cartMetaData, losg);
            var isESimWithAcc = ((_a = losg === null || losg === void 0 ? void 0 : losg.losgType) === null || _a === void 0 ? void 0 : _a.toUpperCase()) === 'ACC' &&
                ((_b = _this.eapFlowContext) === null || _b === void 0 ? void 0 : _b.simType) === 'eSIM';
            var lineDisplayHeaderText = Utils.getDeviceHeader(lineNumber, losg, ++index, _this.externalOrderSourceType, _this.eapFlowContext, _this.cartSummaryCMSData, _this.payload, _this.isAALFlow, _this.isMixedCart);
            if (losg.losgTaxInfo) {
                losg.losgTaxInfo.lineName = lineDisplayHeaderText;
            }
            var lineDisplayName = (losg.losgType.toUpperCase() !== 'CHANGE'
                && !_this.isExpressUp() && !_this.isCommonCart && !isESimWithAcc &&
                React.createElement("div", { className: _this.newWireless ? styles.lineEditremoveContainer : '' },
                    React.createElement(ui_components_1.Label, { data: { isDecodingRequired: false, text: lineDisplayHeaderText }, options: {
                            className: _this.newWireless ? styles.linename : styles.line,
                        }, testId: utils_1.default('WRLS', 'Device', "Header_" + index) }),
                    losg.losgType.toUpperCase() !== 'UP' && !_this.isAALFlow &&
                        _this.cartData._cartCreationSource === 'PSC' &&
                        _this.showEditAndRemove(losg, _this.cartData.qualifierPlanName, _this.filteredLosgsData.length, index)));
            var imageContainer;
            var deviceName;
            var retalPrice;
            var deviceTax;
            var deviceLable;
            var lineItemData;
            var accessoryLineItems = [];
            var items = wlsUtils.organizeLineItems(Object.values(losg.lineItems), _this.isMixAndMatch, losg);
            var accessoryPriceView = [];
            var accesoryRtiOosMessage = [];
            var isDeviceItems = [];
            var lineItemDisplay = items.map(function (lineItem, secindex) {
                var _a;
                var keyId = "deviceInfo" + losg.id + "_" + secindex;
                if (lineItem.uiDisplayLineItem) {
                    var subscriber = losg.subscriberName;
                    if (lineItem.itemType.toUpperCase() === 'DEVICE') {
                        lineItemData = lineItem;
                        var imgInfo = wlsUtils.getItemImage(lineItem, losg, _this.isCommonCart);
                        deviceName = _this.displayDeviceLine(lineItem, losg, _this.payload);
                        var modelName = lineItem && lineItem.hardGood && lineItem.hardGood.make &&
                            lineItem.hardGood
                                .model ? (lineItem.hardGood.make + " " + lineItem.hardGood.model)
                            : '';
                        deviceLable = _this.displayEditCapacityModal(lineItem, losg, _this.payload.enableCommitmentViewDate, modelName, wlsUtils.getSubscriberNumber(losg), _this.cartSummaryCMSData.editDeviceLabel);
                        if (imgInfo && imgInfo.imageUrl && _this.externalOrderSourceType !== 'BMWSMART') {
                            imageContainer = _this.getDeviceImgContainer(imgInfo, styles.deviceImageContainer, styles.simImg);
                        }
                        retalPrice = _this.showRetailPrice(lineItem);
                        isDeviceItems.push(true);
                        deviceTax = (_a = lineItem.price) === null || _a === void 0 ? void 0 : _a.tax;
                    }
                    var isAccessoryLineItem = lineItem.itemType.toUpperCase() === 'ACCESSORY';
                    if (isAccessoryLineItem) {
                        var accessoryElement = (React.createElement("div", { key: keyId }, _this.showlineItemContent(lineItem, losg, lineDisplayHeaderText)));
                        var errorMessage = (React.createElement("div", { key: keyId }, wirelessRTI.displayRtiOosAccessoryMessage(lineItem, losg, _this.editLineForPscCustomers, _this.changeAccessoryQuantity, editUrl)));
                        accesoryRtiOosMessage.push(errorMessage);
                        accessoryPriceView.push(accessoryElement);
                        accessoryLineItems.push(lineItem);
                    }
                    return (React.createElement("div", { key: keyId },
                        (lineItem.itemType.toUpperCase() === 'SHAREDDATAFEATURE' ||
                            ((losg === null || losg === void 0 ? void 0 : losg._fnCaribbean) && lineItem.itemType.toUpperCase() === 'VOICEPLAN'))
                            && _this.externalOrderSourceType !== 'BMWSMART'
                            && _this.showPlanInfoAtLine(lineItem, losg.mnmPlanItems, index, subscriber, _this.payload.enableSignatureEnhancedExperience),
                        lineItem.itemType.toUpperCase() !== 'SHAREDDATAFEATURE' &&
                            //  !(this.enableWirelessInsurance(losg) &&
                            //   lineItem.itemType.toUpperCase() === 'FEATURE') &&
                            lineItem.itemType.toUpperCase() !== 'SHAREDDATAGROUP' &&
                            lineItem.itemType.toUpperCase() !== 'VOICEPLAN' &&
                            lineItem.itemType.toUpperCase() !== 'ACCESSORY' &&
                            Utils.showEarlyUpgradeLineItem(lineItem.itemType, _this.earlyUpgradeAmount)
                            &&
                                React.createElement(React.Fragment, null,
                                    _this.showlineItemContent(lineItem, losg, lineDisplayHeaderText),
                                    lineItem.itemType.toUpperCase() === 'DEVICE' &&
                                        React.createElement("div", { className: styles.flexView }, retalPrice),
                                    _this.showInstallmentMessage(lineItem, losg)),
                        _this.showWaivedText(lineItem),
                        _this.showPromotions(lineItem, isAccessoryLineItem)));
                }
                else {
                    return (React.createElement(React.Fragment, { key: keyId }));
                }
            });
            var rtiOosDeviceMessage = losg && items &&
                wirelessRTI.displayRtiOosDeviceMessage(losg, _this.filteredLosgsData.length, _this.editLineForPscCustomers, _this.removeLineForPscCustomers, deviceLable, _this.showEditOptions, _this.payload, editUrl);
            var accessoryImageContainer = [];
            var accessoryDisplay = _this.getAccessoryFragments(items, losg, lineDisplayHeaderText);
            accessoryImageContainer = _this.getAccessoryImageContainers(items, accessoryImageContainer);
            return (React.createElement(React.Fragment, { key: "losgInfo" + index }, _this.showCartView(lineItemDisplay, losg, accesoryRtiOosMessage, rtiOosDeviceMessage, imageContainer, lineDisplayName, deviceName, index, retalPrice, deviceTax, accessoryDisplay, accessoryImageContainer, accessoryPriceView, isDeviceItems, lineItemData, accessoryLineItems, isMDPPInsurance)));
        })));
    };
    WirelessCart.prototype.displayPlanDetails = function () {
        var _this = this;
        var pricingType = PriceContainerProps_1.PricingType.XSMALL;
        var isPlanHeadingDisplayed = false;
        var isExpressView = this.isExpressUp();
        this.activationLineItemContent = [];
        return (React.createElement(React.Fragment, null,
            this.filteredLosgsData.map(function (losg, index) {
                if ((losg.losgType.toUpperCase() === 'CHANGE' &&
                    !losg.displayLine) || _this.displayPlanDetailsinModal(_this.payload)) {
                    return '';
                }
                if (Object.values(losg.lineItems).
                    filter(function (item) {
                    var _a;
                    return (((_a = item.itemType) === null || _a === void 0 ? void 0 : _a.toUpperCase().search('SHAREDDATAGROUP|SHAREDDATAFEATURE|VOICEPLAN')) > -1) &&
                        item.uiDisplayLineItem;
                }).length < 1) {
                    return '';
                }
                return (React.createElement("div", { key: "linePlan" + index },
                    React.createElement("div", null,
                        React.createElement(React.Fragment, null,
                            !isPlanHeadingDisplayed &&
                                React.createElement("h2", { className: isExpressView ? styles.expupLineHeader : styles.line },
                                    _this.cartSummaryCMSData.planLineHeading,
                                    isPlanHeadingDisplayed = true),
                            wlsUtils.organizeLineItems(Object.values(losg.lineItems), _this.isMixAndMatch).map(function (lineItem, secindex) {
                                var _a, _b;
                                var lineItemPriceData = wlsUtils.getLineItemPriceData(lineItem, _this.isMixAndMatch, true);
                                if (isExpressView) {
                                    lineItemPriceData.lineItemPrice.billingNote = '';
                                }
                                if (losg.displayLine && lineItem.uiDisplayLineItem &&
                                    (lineItem.itemType.toUpperCase() === 'SHAREDDATAGROUP' ||
                                        lineItem.itemType.toUpperCase() === 'SHAREDDATAFEATURE' ||
                                        lineItem.itemType.toUpperCase() === 'VOICEPLAN')) {
                                    lineItemPriceData.lineItemPrice.price = (_this.isAALFlow ||
                                        _this.isMixedCart) ?
                                        parseFloat("" + lineItemPriceData.lineItemPrice.price) :
                                        _this.sdpData.price
                                            + parseFloat("" + lineItemPriceData.lineItemPrice.price);
                                }
                                {
                                    _this.getActivationLineItemContent(lineItem, index);
                                }
                                return (React.createElement("div", { key: "linePlanInfo" + secindex }, losg.displayLine && lineItem.uiDisplayLineItem &&
                                    (lineItem.itemType.toUpperCase() === 'SHAREDDATAGROUP'
                                        || lineItem.itemType.toUpperCase() === 'SHAREDDATAFEATURE'
                                        || lineItem.itemType.toUpperCase() === 'VOICEPLAN') &&
                                    React.createElement("div", null,
                                        (lineItem.itemType.toUpperCase() === 'SHAREDDATAGROUP' ||
                                            lineItem.itemType.toUpperCase() === 'VOICEPLAN') &&
                                            React.createElement("div", { className: isExpressView ? [styles.lineItems,
                                                    styles.expupLineitemContainer].join(' ') : styles
                                                    .lineItems },
                                                React.createElement(ui_components_1.Label, { data: {
                                                        isDecodingRequired: false,
                                                        text: lineItem.displayName,
                                                    }, options: { className: styles.itemName } }),
                                                lineItem.price && lineItemPriceData &&
                                                    lineItemPriceData.lineItemPrice &&
                                                    lineItemPriceData.lineItemPrice.price > 0 &&
                                                    React.createElement(ui_components_1.PriceContainer, { testId: utils_1.default('WRLS', "lineItem_" + secindex), data: lineItemPriceData.lineItemPrice, options: {
                                                            className: styles.lineItem,
                                                            decimalPoints: 2,
                                                            type: pricingType,
                                                        } })),
                                        lineItem.itemType.toUpperCase() === 'SHAREDDATAGROUP' &&
                                            !(_this.isAALFlow || _this.isMixedCart) &&
                                            React.createElement("div", { className: styles.sdpDisclaimer },
                                                _this.sdpData.count === 1 &&
                                                    _this.cartSummaryCMSData.deviceAccessCharge1
                                                        .replace('{0}', _this.sdpData.price.toFixed(2).toString()),
                                                _this.sdpData.count > 1 && _this.cartSummaryCMSData
                                                    .deviceAccessCharge2.replace('{0}', (_a = _this.sdpData.price.toFixed(2)) === null || _a === void 0 ? void 0 : _a.toString())
                                                    .replace('{1}', (_b = _this.sdpData.count) === null || _b === void 0 ? void 0 : _b.toString())),
                                        losg.displayLine && lineItem.promotionReferences &&
                                            ((!(_this.isAALFlow || _this.isMixedCart) &&
                                                lineItem.itemType.
                                                    toUpperCase() === 'SHAREDDATAFEATURE')
                                                || lineItem.itemType
                                                    .toUpperCase() === 'SHAREDDATAGROUP') &&
                                            _this.cartData.promotions &&
                                            _this.cartData.promotions.length > 0 &&
                                            React.createElement("div", { className: styles.promoContainer }, _this.checkDuplicatePromo(lineItem)))));
                            })))));
            }),
            this.activationLineItemContent.length > 0 && React.createElement("div", null,
                this.activationLineItemContent,
                " ")));
    };
    return WirelessCart;
}(WirelessCartHelper_1.default));
exports.default = WirelessCart;
//# sourceMappingURL=WirelessCart.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@idse/cart-ui/components/CartLob/WirelessCart/WirelessCart.js
// module id = 763
// module chunks = 8